import { EditOutlined } from '@ant-design/icons';
import React, { ReactElement } from 'react';

/**
 * Renders an email address with an edit icon for visual indication.
 * When clicked, it triggers the provided `onClick` handler.
 */
export default function EmailEdit(props: {
    email: string;
    onClick: () => void;
}): ReactElement {
    const { email, onClick } = props;

    return (
        <a className='email-edit' onClick={onClick}>
            {email}
            <EditOutlined />
        </a>
    );
}